module.exports = __webpack_public_path__ + "img/img-yingjian-s5.b37941c5.jpg";